"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
const STRICT = Symbol('strict');
const INITIALIZED = Symbol('initialized');
class Configuration {
    constructor() {
        this[_a] = false;
        this[_b] = false;
    }
    setStrict(strict = false) {
        this[STRICT] = strict;
    }
    isStrict() {
        return this[STRICT];
    }
    setInitialized(initialized = false) {
        this[INITIALIZED] = initialized;
    }
    isInitialized() {
        return this[INITIALIZED];
    }
}
exports.default = Configuration;
_a = STRICT, _b = INITIALIZED;
//# sourceMappingURL=Configuration.js.map